import { isObject, isValidHttpUrl } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { PublishStatusEnum } from "../enums/publishStatus.enum";
import { IsNotEmpty } from "@pineapplelab/validators";
import { Course } from "./course";
import { Language } from "../utils/language";
import { DocumentReference } from "@angular/fire/compat/firestore";
import { ICurrencyData } from "./util/currencyData";
import { CategoryCardAction } from "../enums/categoryCardAction.enum";
import { User } from "./user";

export class Category extends FBase {

	name: string = null;
	description: string = null;
	languages: Language[] = [];
    status: PublishStatusEnum = null;
	image: string = null;
	coursesQuantity: number = 0;
	assigned: boolean = false;
	nameLowercase: string = null;
	completedPercentage: number = 0;
	readyToPublish: boolean = false;
	requirePassToContinue: boolean = true;
	passPercentage: number = null;
	courses: DocumentReference[] = [];
	createdByAdmin: boolean = false;
	language: Language = null;
	inPersonMode: boolean = false;
	autoGrantRetakes: boolean = false;
	enforceCourseOrder: boolean = false;
	enrollments: number = 0;

	/**
	 * Set on duplicates: the translations were copied from the source category and won't reflect
	 * its new title or description until they're regenerated. Cleared by "Regenerate all" in the
	 * category form.
	 */
	translationsInherited: boolean = false;

	author: string = null;
	price: number = null;
	currency: ICurrencyData = null;
	duration: number = null;

	// url of promotional video (if the tenant has promotional video)
	video: string = null;
	videoThumbnail: string = null;

	__courses: Course[] = [];
	__categoryCardAction: CategoryCardAction = CategoryCardAction.AVAILABLE;
	@IsNotEmpty({ label: "Image" }) __fileImage: File;
	__promotionalVideo: File = null;
	__promotionalVideoThumbnail: File | string = null;

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
			this.setPromotionalVideoThumbnail();
		}
	}

	private setPromotionalVideoThumbnail(): void {
		if (this.videoThumbnail && isValidHttpUrl(this.videoThumbnail)) {
			this.__promotionalVideoThumbnail = this.videoThumbnail;
		}
	}
}
export namespace Category {
	export const PATH = 'categories';

	export const COUNTERCOLLECTION= 'counters';
	export const COUNTER= 'categoryCounter';
	export const COUNTERSTART= 900000;

}
